export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold mb-4">麻花影视</h3>
            <p className="text-sm text-white/55 leading-relaxed">
              聚合神马影视、樱花影视、小小影视、久久影视、飘花影视、丫丫影视、琪琪影视、蚂蚁影视等多家主流平台的优质影视资源，为您提供一站式高清观影体验。
            </p>
          </div>
          <div>
            <h3 className="text-sm font-heading font-semibold mb-4 text-white/80">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#cards" className="text-sm text-white/55 hover:text-white transition-colors">精选推荐</a></li>
              <li><a href="#index" className="text-sm text-white/55 hover:text-white transition-colors">影视合集</a></li>
              <li><a href="#carousel" className="text-sm text-white/55 hover:text-white transition-colors">热门专题</a></li>
              <li><a href="#updates" className="text-sm text-white/55 hover:text-white transition-colors">更新快讯</a></li>
              <li><a href="#faq" className="text-sm text-white/55 hover:text-white transition-colors">常见问题</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-heading font-semibold mb-4 text-white/80">聚合平台</h3>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-white/45">神马影视</span></li>
              <li><span className="text-sm text-white/45">樱花影视</span></li>
              <li><span className="text-sm text-white/45">小小影视</span></li>
              <li><span className="text-sm text-white/45">久久影视</span></li>
              <li><span className="text-sm text-white/45">飘花影视</span></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-heading font-semibold mb-4 text-white/80">合作伙伴</h3>
            <p className="text-sm text-white/40 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。如有合作意向，欢迎通过联系方式与我们沟通。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#contact" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 text-white/70 hover:text-white transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 text-white/70 hover:text-white transition-colors cursor-pointer">
                <i className="ri-arrow-up-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/35">
            &copy; {new Date().getFullYear()} 麻花影视 — 影视资源聚合平台，所有资源均来自互联网公开内容。
          </p>
          <p className="text-xs text-white/30">
            仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}